module.exports = __webpack_public_path__ + "img/back-button.47cfa8a8.svg";